<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="mt-4"
    />

    <button
      v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
      v-b-tooltip.hover
      class="btn btn-success float-right m-2"
      title="Neue Pauschale erfassen"
      type="button"
      @click="$refs.lumpSumCreate.show()"
    >
      <i class="fas fa-plus" />
    </button>

    <h3 class="mt-4">
      Pauschalen
    </h3>

    <div v-if="wageSupplementLumpSum.length">
      <v-card
        v-for="(lumpSum, lumpSumIndex) in wageSupplementLumpSum"
        :key="lumpSum.id"
        class="mt-5"
      >
        <u-loader
          v-if="isLoading"
          class="mt-5"
        />

        <div
          v-else
          class="card-body"
        >
          <div v-if="!isEditable[lumpSumIndex]">
            <!--  No Edit -->
            <div class="card-title ml-5">
              <b-row>
                <b-col cols="1">
                  <label class="float-right defaultLabel"> Name: </label>
                </b-col>
                <b-col cols="8">
                  <label class="defaultLabel">
                    {{ lumpSum.lumpSumTypeName }}
                  </label>
                </b-col>
              </b-row>
            </div>
            <div class="card-text ml-5">
              <b-row>
                <b-col cols="1">
                  <label class="float-right defaultLabel"> Deutsch: </label>
                </b-col>
                <b-col cols="8">
                  <p>
                    {{ lumpSum.wageSupplementLumpSumTypeContents[0].value }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="1">
                  <label class="float-right defaultLabel"> Französisch: </label>
                </b-col>
                <b-col cols="8">
                  <p>
                    {{ lumpSum.wageSupplementLumpSumTypeContents[1].value }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="1">
                  <label class="float-right defaultLabel"> Italienisch: </label>
                </b-col>
                <b-col cols="8">
                  <p>
                    {{ lumpSum.wageSupplementLumpSumTypeContents[2].value }}
                  </p>
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-else>
            <!--  Edit Mode -->
            <div class="card-title ml-5">
              <b-row>
                <b-col cols="1">
                  <label class="float-right defaultLabel"> Name </label>
                </b-col>
                <b-col cols="8">
                  <label class="defaultLabel">
                    {{ lumpSum.lumpSumTypeName }}
                  </label>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="1">
                  <label class="float-right defaultLabel">
                    Übersetzungen
                  </label>
                </b-col>
                <b-col cols="8">
                  <v-text-field
                    v-model="lumpSum.wageSupplementLumpSumTypeContents[0].value"
                    label="Deutsch"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1" />
                <b-col cols="8">
                  <v-text-field
                    v-model="lumpSum.wageSupplementLumpSumTypeContents[1].value"
                    label="Französisch"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1" />
                <b-col cols="8">
                  <v-text-field
                    v-model="lumpSum.wageSupplementLumpSumTypeContents[2].value"
                    label="Italienisch"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="mt-4">
            <v-btn
              color="#e72b37"
              raised
              style="color: white"
              @click="deleteWageSupplementLumpSum(lumpSum)"
            >
              <i class="fas fa-trash-alt mr-3" /> Löschen
            </v-btn>
            <v-btn
              v-if="!isEditable[lumpSumIndex]"
              class="btn-left"
              color="success"
              raised
              @click="editWageSupplementLumpSum(lumpSumIndex)"
            >
              <i class="fas fa-edit mr-3" /> Bearbeiten
            </v-btn>

            <span v-else>
              <v-btn
                v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
                class="btn-left"
                color="grey lighten-1"
                raised
                style="color: white"
                @click="cancelEditWageSupplementLumpSum(lumpSumIndex)"
              >
                <i class="fas fa-ban mr-3" /> Abbrechen
              </v-btn>
              <v-btn
                v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
                class="btn-left"
                color="success"
                raised
                @click="saveWageSupplementLumpSum(lumpSumIndex)"
              >
                <i class="fas fa-save mr-3" /> Speichern
              </v-btn>
            </span>
          </div>
        </div>
      </v-card>
    </div>

    <!-- Create LumpSum -->
    <b-modal
      id="lumpSumCreate"
      ref="lumpSumCreate"
      hide-footer
      no-fade
      size="lg"
      title="Neue Pauschale erfassen"
    >
      <div class="p-4">
        <h5>Pauschalen Name</h5>
        <v-text-field
          v-model="createWageSuppObj.lumpSumTypeName"
          label="Name"
        />
        <h5 class="mt-4">
          Übersetzungen
        </h5>
        <v-text-field
          v-model="createWageSuppObj.wageSupplementLumpSumTypeContents[0].value"
          label="Deutsch"
        />
        <v-text-field
          v-model="createWageSuppObj.wageSupplementLumpSumTypeContents[1].value"
          label="Französisch"
        />
        <v-text-field
          v-model="createWageSuppObj.wageSupplementLumpSumTypeContents[2].value"
          label="Italienisch"
        />
      </div>
      <hr class="custom_hr">
      <div class="mt-4">
        <v-btn
          :disabled="
            !createWageSuppObj.lumpSumTypeName ||
              !createWageSuppObj.wageSupplementLumpSumTypeContents[0].value ||
              !createWageSuppObj.wageSupplementLumpSumTypeContents[1].value ||
              !createWageSuppObj.wageSupplementLumpSumTypeContents[2].value
          "
          class="btn-left"
          color="success"
          raised
          @click="createWageSupplementLumpSum"
        >
          <i class="fas fa-plus mr-3" /> Neu Erfassen
        </v-btn>

        <v-btn
          color="grey lighten-1"
          raised
          style="color: white"
          @click="cancelCreate"
        >
          <i class="fas fa-ban mr-3" /> Abbrechen
        </v-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  GetWageSupplementLumpSum,
  CreateWageSupplementLumpSum,
  SaveWageSupplementLumpSum,
  DeleteWageSupplementLumpSum,
} from "@/services/wageSupplement.lumpSum.service";

export default {
  name: "WageSupplementLumpSumType",

  data() {
    return {
      wageSupplementLumpSum: [],
      originalWageSupplementLumpSum: [],
      errorObject: null,
      createWageSuppObj: {},
      isEditable: [],
      isLoading: false,
    };
  },

  created() {
    this.loadWageSupplementLumpSum();
    this.setDefaulCreateObj();
  },

  methods: {
    saveWageSupplementLumpSum(lumpSumIndex) {
      this.isLoading = true;

      SaveWageSupplementLumpSum(
        this.wageSupplementLumpSum[lumpSumIndex],
        () => {
          this.isEditable[lumpSumIndex] = false;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },

    cancelEditWageSupplementLumpSum(lumpSumIndex) {
      this.isLoading = true;
      this.isEditable[lumpSumIndex] = false;

      this.wageSupplementLumpSum[lumpSumIndex] = JSON.parse(
        JSON.stringify(this.originalWageSupplementLumpSum[lumpSumIndex]),
      );

      this.isLoading = false;
    },

    editWageSupplementLumpSum(lumpSumIndex) {
      this.isLoading = true;
      this.isEditable[lumpSumIndex] = true;
      this.isLoading = false;
    },
    deleteWageSupplementLumpSum(lumpSum) {
      this.isLoading = true;

      DeleteWageSupplementLumpSum(
        lumpSum.id,
        () => {
          this.loadWageSupplementLumpSum();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    loadWageSupplementLumpSum() {
      this.isLoading = true;
      this.isEditable = [];
      GetWageSupplementLumpSum(
        (response) => {
          this.wageSupplementLumpSum = response;
          this.originalWageSupplementLumpSum = JSON.parse(
            JSON.stringify(response),
          );
          if (this.wageSupplementLumpSum.length > 0) {
            this.isEditable = new Array(this.wageSupplementLumpSum.length).fill(
              false,
            );
          }

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    createWageSupplementLumpSum() {
      CreateWageSupplementLumpSum(
        this.createWageSuppObj,
        () => {
          this.loadWageSupplementLumpSum();
          this.cancelCreate();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    cancelCreate() {
      this.$refs.lumpSumCreate.hide();
      this.setDefaulCreateObj();
    },
    setDefaulCreateObj() {
      this.createWageSuppObj = {
        id: 0,
        lumpSumTypeName: "",
        wageSupplementLumpSumTypeContents: [
          {
            id: 0,
            wageSupplementLumpSumTypeId: 0,
            value: "",
            language: "de-CH",
          },
          {
            id: 0,
            wageSupplementLumpSumTypeId: 0,
            value: "",
            language: "fr-CH",
          },
          {
            id: 0,
            wageSupplementLumpSumTypeId: 0,
            value: "",
            language: "it-CH",
          },
        ],
      };
    },
  },
};
</script>

<style scoped></style>
